import React from "react";
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Legend, ResponsiveContainer, Tooltip, Label
} from "recharts";
import cohortData from "../data/data.json";
import CustomToolTip from "./CustomToolTip";

const MAGENTA = "#E3007D";
const CYAN = "#009DE4";
const NAVY = "#1B3D67";

const formatter = (value) => "$" + commas(value);
const commas = (x) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

class App extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            toolTipTitle: "none",
            barTitle: "none",
            netPrice: "none"
        }
    }

    render() {
        return (
            <ResponsiveContainer width="100%" height={500}>
                <BarChart
                    data={cohortData}
                    margin={{
                        top: 5, right: 30, left: -80, bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" height={100}>
                        <Label value={"Year"}  />
                    </XAxis>
                    <YAxis width={200} tickFormatter={formatter}>
                        <Label value={"Net Price"} angle={-90} />
                    </YAxis>
                    <Tooltip cursor={false} content={<CustomToolTip barTitle={this.state.barTitle} toolTipTitle={this.state.toolTipTitle} netPrice={this.state.netPrice}/>}/>
                    <Bar dataKey="public" fill={MAGENTA} onMouseOver={(bar) => {
                        this.setState({
                            currentBar: bar,
                            toolTipTitle: bar.name,
                            barTitle: "public",
                            netPrice: bar.public
                        })
                    }}/>
                    <Bar dataKey="non-profit" fill={CYAN}  onMouseOver={(bar) => {
                        this.setState({
                            currentBar: bar,
                            toolTipTitle: bar.name,
                            barTitle: "non-profit",
                            netPrice: bar["non-profit"]
                        })
                    }}/>
                    <Bar dataKey="for-profit" fill={NAVY}  onMouseOver={(bar) => {
                        this.setState({
                            currentBar: bar,
                            toolTipTitle: bar.name,
                            barTitle: "for-profit",
                            netPrice: bar["for-profit"]
                        })
                    }}/>
                </BarChart>
            </ResponsiveContainer>
        );
    }
}

export default App;
